import { useEffect, useState } from "react";
import "./FloatingHearts.css";

const FloatingHearts = () => {
  const [hearts, setHearts] = useState([]);

  useEffect(() => {
    const createHeart = () => {
      const heart = {
        id: Date.now() + Math.random(),
        left: Math.random() * 100,
        delay: Math.random() * 2,
        duration: 3 + Math.random() * 2,
        size: 20 + Math.random() * 15
      };
      return heart;
    };

    // Create initial hearts
    const initialHearts = Array.from({ length: 15 }, createHeart);
    setHearts(initialHearts);

    // Add new hearts periodically
    const interval = setInterval(() => {
      setHearts((prev) => {
        const newHeart = createHeart();
        // Keep max 20 hearts on screen
        if (prev.length < 20) {
          return [...prev, newHeart];
        }
        return [...prev.slice(1), newHeart];
      });
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="floating-hearts">
      {hearts.map((heart) => (
        <div
          key={heart.id}
          className="heart"
          style={{
            left: `${heart.left}%`,
            animationDelay: `${heart.delay}s`,
            animationDuration: `${heart.duration}s`,
            fontSize: `${heart.size}px`
          }}
        >
          {Math.random() > 0.5 ? "♥" : "💕"}
        </div>
      ))}
    </div>
  );
};

export default FloatingHearts;
